import { render, staticRenderFns } from "./SubscribeTestimonials.vue?vue&type=template&id=789553aa&scoped=true&"
import script from "./SubscribeTestimonials.vue?vue&type=script&lang=js&"
export * from "./SubscribeTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeTestimonials.vue?vue&type=style&index=0&id=789553aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789553aa",
  null
  
)

export default component.exports